import script from "./Messages.vue?vue&type=script&setup=true&lang=ts"
export * from "./Messages.vue?vue&type=script&setup=true&lang=ts"

import "./Messages.vue?vue&type=style&index=0&id=771b393d&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-771b393d"]])

export default __exports__